module.exports = __webpack_public_path__ + "static/media/soriyori.c003641b.jpg";